import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Tooltip, TooltipApp, TooltipTour } from '@ui/shared/model';
import {
  tooltipsSeenMutation,
  tooltipsUnseenQuery,
  tooltipToursUnseenQuery
} from './tooltip.queries';

interface TooltipsUnseenResponse {
  tooltipsUnseen: Tooltip[];
}

interface TooltipToursUnseenResponse {
  tooltipToursUnseen: TooltipTour[];
}

@Injectable({
  providedIn: 'root'
})
export class TooltipFacade {
  private apollo = inject(Apollo);

  public tooltipsUnseen(path: string) {
    return this.apollo
      .query<TooltipsUnseenResponse>({
        query: tooltipsUnseenQuery,
        variables: { input: { path, app: TooltipApp.PROPERTY_SEARCHER } },
        fetchPolicy: 'no-cache'
      })
      .pipe(map(response => response.data?.tooltipsUnseen ?? []));
  }

  public tooltipToursUnseen(path: string) {
    return this.apollo
      .query<TooltipToursUnseenResponse>({
        query: tooltipToursUnseenQuery,
        variables: { input: { path, app: TooltipApp.PROPERTY_SEARCHER } },
        fetchPolicy: 'no-cache'
      })
      .pipe(map(response => response.data?.tooltipToursUnseen ?? []));
  }

  public tooltipsSeen(ids: number[]) {
    return this.apollo.mutate({
      mutation: tooltipsSeenMutation,
      variables: {
        input: { tooltipIdsSeen: ids, app: TooltipApp.PROPERTY_SEARCHER }
      }
    });
  }
}
